import { render, staticRenderFns } from "./ItemChipNumber.vue?vue&type=template&id=bf20ae40&scoped=true"
import script from "./ItemChipNumber.vue?vue&type=script&lang=ts"
export * from "./ItemChipNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20ae40",
  null
  
)

export default component.exports